import { CollageFamily } from '@/content/collageTemplates'
import { OutputPresetId } from '@/content/instagram'
import { NodeKind } from '@/core/document'
import { useEditSession } from '@/core/store/editSession'
import { TEST_IDS } from '@/lib/testIds'
import { enterCollage } from '@/tools/collage/actions'
import { PresetPicker } from '@/tools/output/PresetPicker'
import { SplitPicker } from '@/tools/output/SplitPicker'
import { ChoiceTile } from '@/ui/ChoiceTile'
import { CollageFamilyIllustration } from '@/ui/illustrations/PanelIllustrations'

export function FormatPanel() {
  const document = useEditSession((state) => state.document)
  if (!document) throw new Error('Format panel requires a loaded document')

  return (
    <section className="space-y-5" aria-labelledby="output-preset-heading">
      <h2 id="output-preset-heading" className="font-semibold">Format</h2>
      <div className="space-y-2">
        <h3 className="text-sm font-medium">Shape</h3>
        <PresetPicker />
      </div>
      {document.output.presetId === OutputPresetId.Story ? null : (
        <div className="space-y-2">
          <h3 className="text-sm font-medium">Split</h3>
          <SplitPicker />
        </div>
      )}
      <div className="space-y-2">
        <h3 className="text-sm font-medium">Collage</h3>
        <ChoiceTile
          ariaLabel={document.root.kind === NodeKind.Collage ? 'Edit collage' : 'Make a collage'}
          label="Collage"
          illustration={<CollageFamilyIllustration family={CollageFamily.Grid} />}
          selected={document.root.kind === NodeKind.Collage}
          data-testid={TEST_IDS.collageEnter}
          className="w-full"
          onClick={enterCollage}
        />
      </div>
    </section>
  )
}
